import React, { Fragment, useState, ChangeEvent } from "react";
import { IconButton, Dialog, DialogTitle, DialogContent, Grid, DialogActions, Button, TextField } from "@material-ui/core";
import { Settings as SettingsIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { thunkUpdateSettings } from "../../thunks";


export default function Setting() {
  const [folder, setFolder] = useState('');
  const currentFolder = useSelector((state: RootState) => state.setting.folder);
  const [archiveFolder, setArchiveFolder] = useState('');
  const currentArchiveFolder = useSelector((state: RootState) => state.setting.archiveFolder);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setFolder(currentFolder);
    setArchiveFolder(currentArchiveFolder);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleFolderChange = (e: ChangeEvent<HTMLInputElement>) => setFolder(e.target.value);
  const handleArchiveFolderChange = (e: ChangeEvent<HTMLInputElement>) => setArchiveFolder(e.target.value);
  const submitable = !!folder && !!archiveFolder;

  const dispatch = useDispatch();
  const handleSubmit = () => submitable && dispatch(thunkUpdateSettings({folder, archiveFolder})) && handleClose();

  return (
    <Fragment>

    <IconButton color="inherit" onClick={handleOpen}>
      <SettingsIcon />
    </IconButton>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle>
          Settings
      </DialogTitle>
        <DialogContent dividers style={{ width: '600px' }}>
          <Grid container spacing={3}>
            <Grid item xs={3} className="form-row-label">
              Download folder:
            </Grid>
            <Grid item xs={9} className="form-row-label">
              <TextField margin="dense" variant="outlined" value={folder} fullWidth
                error={!folder}
                onChange={handleFolderChange} />
            </Grid>
            <Grid item xs={3} className="form-row-label">
              Archive folder:
            </Grid>
            <Grid item xs={9} className="form-row-label">
              <TextField margin="dense" variant="outlined" value={archiveFolder} fullWidth
                error={!archiveFolder}
                onChange={handleArchiveFolderChange} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleSubmit} disabled={!submitable} color="primary">
            Ok
        </Button>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
        </Button>
        </DialogActions>
      </Dialog >
    </Fragment>
  )
}